import * as React from "react";
import { PersonListDto, PersonClient } from "@app/api2/api";
import { BPColumn } from "@common/BPReactTable";
import { Button, Container, TabPane } from "@/components/bp/bp-ui";
import { PageHeader } from "@common/PageHeader";
import { Link } from "react-router-dom";
import { buildUrl, AppRoutes } from "../AppRoutes";
import { toDate, toDateTime } from "@common/Utils";
import { useUser } from "../Contexts/UserContext";
import { RoutedTab } from "../CaseRun/Details/RoutedTab";
import { EnrollmentSearch } from "./Search/Search";
import { BPDataTable3 } from "../Common/DataTable/BPDataTable3";
import { useTranslation2 } from "../Contexts/TranslationContext2";
import { BPButton } from "@/components/bp/bpbutton";
import { BPContainer } from "@/components/bp/bpcontainer";

interface EnrollmentsProps {
}

const client = new PersonClient();

export const Enrollments: React.FC<EnrollmentsProps> = () => {

    const user = useUser();

    const { translations: t } = useTranslation2();

    const canCreateCase = user?.user?.canCreateEnrollments;

    const columns: BPColumn<PersonListDto>[] = [
        {
            Header: t.metadata.firstName,
            accessor: 'firstName',
            Cell: cell => (
                <Link to={buildUrl(AppRoutes.ProfilesMetadataEdit, { metaId: cell.row.original.id })}>{cell.value}</Link>
            ),
        },
        {
            Header: t.metadata.lastName,
            accessor: 'lastName',
        },
        {
            Header: t.metadata.middleName,
            accessor: 'middleName',
            tableCellProps: { width: 5 },
        },
        {
            Header: t.metadata.dateOfBirth,
            accessor: 'dob',
            tableCellProps: { width: 5 },
            Cell: cell => {
                return cell.value ? <>{toDate(cell.value)}</> : <></>;
            },
        },
        {
            Header: t.common.created,
            accessor: 'createdAt',
            tableCellProps: { width: 5 },
            Cell: cell => {
                return cell.value ? <>{toDateTime(cell.value)}</> : <></>;
            },
        },
    ];

    return (
        <BPContainer>
            <RoutedTab tabs={[{
                path: '/',
                enabled: true,
                exact: true,
                to: buildUrl(AppRoutes.ProfilesMetadata, {}),
                menuItem: t.metadata.enrollments, render: () => <TabPane>
                    <PageHeader
                        header={t.metadata.enrollments}
                        renderRight={() =>
                        (canCreateCase &&
                            <BPButton as={Link} to={buildUrl(AppRoutes.ProfilesMetadataCreate, {})}>
                                {t.metadata.enrollmentCreate}
                            </BPButton>
                        )
                        }
                    />
                    <BPDataTable3
                        storeKey="enrollments"
                        defaultSortField="name"
                        defaultSortAsc={true}
                        enableSearch={true}
                        dataSource={async (p) => {
                            let pageData = await client.list(p.perPage, p.page, p.sortBy, p.sortDirection, p.searchValue, null);
                            return pageData;
                        }}
                        columns={columns}
                    />
                </TabPane>
            },
            {
                path: 'search',
                enabled: true,
                exact: true,
                to: buildUrl(AppRoutes.ProfilesMetadataSearch, {}),
                menuItem: t.common.search, render: () => <TabPane>
                    <EnrollmentSearch />
                </TabPane>
            }]}>
            </RoutedTab>

        </BPContainer>
    );
};

